import React, { useState, useEffect, useContext } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";

import { TextInput } from "../../../Components/Input/Input";
import { ButtonSave, ButtonClose } from "../../../Components/Button/Button";
import axios from "axios";
import { UrlApi, authorization } from "../../../UrlApi/UrlApi";
import Loading from "../../../Components/Loading/Loading";
import {
  AlertError,
  AlertSuccess,
  AlertWarning,
} from "../../../Components/AlertDialog/AlertDialog";
import SelectAutoComplete from "../../../Components/Input/Input";
import Box from "@mui/material/Box";
import { userData } from "../../../DataContext/DataContext";
import { useRecoilValue } from "recoil";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { InputAdornment, IconButton } from "@mui/material";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Grid from "@mui/material/Unstable_Grid2";

function AddEmployee(props) {
  //props.typeId = 2 คือ ประเภทพนักงานที่เป็น Sales props.typeId = 3 คือพนักงานที่เป็นคนวิ่งงาน
  const user = useRecoilValue(userData);
  const [loading, setLoading] = useState(false);
  const [empCodeErr, setEmpCodeErr] = useState(false);
  const [empTitleIdErr, setEmpTitleIdErr] = useState(false);
  const [empFirstnameErr, setEmpFirstnameErr] = useState(false);
  const [empLastnameErr, setEmpLastnameErr] = useState(false);
  const [empNicknameErr, setEmpNicknameErr] = useState(false);
  const [empTelErr, setEmpTelErr] = useState(false);
  const [pageSize, setPageSize] = useState(50);

  const [empCode, setEmpCode] = useState("");
  const [empTitleId, setEmpTitleId] = useState("");
  const [empFirstname, setEmpFirstname] = useState("");
  const [empLastname, setEmpLastname] = useState("");
  const [empNickname, setEmpNickname] = useState("");
  const [empTel, setEmpTel] = useState("");
  const [titleName, setTitleName] = useState("");
  const [statusActive, setStatusActive] = useState(true);
  const [titleData, setTitleData] = useState([]);

  const onSubmit = async (event) => {
    event.preventDefault();
    if (empCode === "" && props.typeId === 2) {
      setEmpCodeErr(true);
      return false;
    } else {
      setEmpCodeErr(false);
    }
    if (empTitleId === "") {
      setEmpTitleIdErr(true);
      return false;
    } else {
      setEmpTitleIdErr(false);
    }
    if (empFirstname === "") {
      setEmpFirstnameErr(true);
      return false;
    } else {
      setEmpFirstnameErr(false);
    }
    if (empLastname === "" && props.typeId === 3) {
      setEmpLastnameErr(true);
      return false;
    } else {
      setEmpLastnameErr(false);
    }
    if (empTel === "" && props.typeId === 3) {
      setEmpTelErr(true);
      return false;
    } else {
      setEmpTelErr(false);
    }

    const body = {
      empCode,
      empTitleId,
      empFirstname,
      empLastname,
      empNickname,
      empTel,
      statusActive,
      empId: props.empId,
      employeeTypeId: props.typeId
    };

    if (props.empId === null) {
      setLoading(true);
      await axios
        .post(UrlApi + "save_employee_data", body, authorization)
        .then((res) => {
          if (res.data.status === 1) {
            props.onCancel();
            AlertSuccess(res.data.message);
            setLoading(false);
          } else {
            AlertWarning(res.data.message);
            setLoading(false);
          }
        })
        .catch((err) => {
          setLoading(false);
          AlertError(err);
        });
    } else {
      setLoading(true);
      await axios
        .post(UrlApi + "update_employee_data", body, authorization)
        .then((res) => {
          if (res.data.status === 1) {
            props.onCancel();
            AlertSuccess(res.data.message);
            setLoading(false);
          } else {
            AlertWarning(res.data.message);
            setLoading(false);
          }
        })
        .catch((err) => {
          setLoading(false);
          AlertError(err);
        });
    }
  };

  const getData = async () => {
    if (props.empId !== null) {
      setLoading(true);
      await axios
        .post(
          UrlApi + "get_employee_data_for_edit",
          { empId: props.empId },
          authorization
        )
        .then((res) => {    
          setEmpCode(res.data[0].emp_code);
          setEmpTitleId(res.data[0].emp_title_id);
          setTitleName(res.data[0].emp_title_name);
          setEmpFirstname(res.data[0].emp_firstname);
          setEmpLastname(res.data[0].emp_lastname);
          setEmpNickname(res.data[0].emp_nickname);
          setEmpTel(res.data[0].emp_tel);
          setStatusActive(res.data[0].emp_default_active);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          AlertError(err);
        });
    }
    setLoading(true);
    await axios
      .post(UrlApi + "get_title_data", {}, authorization)
      .then((res) => {
        setTitleData(res.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        AlertError(err);
      });

  };

  function isValidEmail(email) {
    return /\S+@\S+\.\S+/.test(email);
  }

  function isValidPassword(passWord) {
    const lower = new RegExp(/(?=.*[a-z])/);
    const upper = new RegExp(/(?=.*[A-Z])/);
    const number = new RegExp(/(?=.*[0-9])/);
    const special = new RegExp(/(?=.*[-_?!@#\$%/^&\*])/);
    const length = new RegExp(/(?=.{8,})/);
    const checkPassword = [
      lower.test(passWord),
      upper.test(passWord),
      number.test(passWord),
      special.test(passWord),
      length.test(passWord),
    ];
    return checkPassword.every((element) => element === true);
  }

  const marginLeft = {
    marginLeft: "9px",
  };

  const handleEnter = (event) => {
    const id = parseInt(event.target.id);
    const form = event.target.form;
    const index = [...form].indexOf(event.target);
    let next = 2;
    if (event.key === "Enter") {
      if (id === 10) {
        onSubmit(event);
        return false;
      }
      switch (id) {
        case 2:
          next = 3;
          break;
        case 3:
          next = 3;
          break;
        case 5:
          next = 4;
          break;     
        default:
          next = 2;
      }
      form.elements[index + next].focus();
      event.preventDefault();
    }
  };

  useEffect(() => {
    getData();
  }, []);
  return (
    <>
      <Dialog
        open={props.open}
        maxWidth="1500"
        PaperProps={{ style: { borderRadius: 10 } }}
      >
        <Box component="form" noValidate onSubmit={onSubmit} sx={{ mt: 1 }}>
          <DialogTitle>
            <label>
              {props.empId === null
                ? props.typeId === 3 ? "เพิ่มข้อมูลพนักงาน" : "เพิ่มข้อมูล Sales"
                : props.typeId === 3 ? 'แก้ไขข้อมูลพนักงาน' : 'แก้ไขข้อมูล Sales'
              }
            </label>
          </DialogTitle>
          <DialogContent dividers="paper">
            <form>
              <table>
                <tr>
                  <td colspan="5">
                    <label style={marginLeft}>{props.typeId === 3 ? 'รหัสพนักงาน(ถ้ามี)' : 'Code Sales'}</label>
                    {
                      <TextInput
                        id="4"
                        value={empCode}
                        onChange={(e) => {
                          setEmpCode(e.target.value);
                          setEmpCodeErr(false);
                        }}
                        error={empCodeErr}
                        onKeyDown={handleEnter}
                        width="100%"
                      />
                    }
                  </td>
                </tr>
                <tr>
                  <td colspan="5">
                    <label style={marginLeft}>คำนำหน้า</label>
                    {
                      <SelectAutoComplete
                        id="5"
                        options={titleData}
                        onChange={(value, valueText) => {
                          setTitleName(valueText);
                          setEmpTitleId(value);
                          setEmpTitleIdErr(false);
                        }}
                        value={titleName}
                        onInputChange={(event, newInputValue) => {}}
                        error={empTitleIdErr}
                        width="100%"
                        onKeyDown={handleEnter}
                      />
                    }
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    <label style={marginLeft}>ชื่อ</label>
                    {
                      <TextInput
                        id="6"
                        onChange={(e) => {
                          setEmpFirstname(e.target.value);
                          setEmpFirstnameErr(false);
                        }}
                        error={empFirstnameErr}
                        value={empFirstname}
                        onKeyDown={handleEnter}
                      />
                    }
                  </td>
                  <td colspan="3">
                    <label style={marginLeft}>นามสกุล</label>
                    {
                      <TextInput
                        id="7"
                        onChange={(e) => {
                          setEmpLastname(e.target.value);
                          setEmpLastnameErr(false);
                        }}
                        error={empLastnameErr}
                        value={empLastname}
                        onKeyDown={handleEnter}
                        width="100%"
                      />
                    }
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    <label style={marginLeft}>ชื่อเล่น</label>
                    {
                      <TextInput
                        id="8"
                        onChange={(e) => {
                          setEmpNickname(e.target.value);
                          setEmpNicknameErr(false);
                        }}
                        error={empNicknameErr}
                        value={empNickname}
                        onKeyDown={handleEnter}
                      />
                    }
                  </td>
                  <td colspan="3">
                    <label style={marginLeft}>เบอร์โทร</label>
                    {
                      <TextInput
                        id="9"
                        onChange={(e) => {
                          setEmpTel(e.target.value);
                          setEmpTelErr(false);
                        }}
                        error={empTelErr}
                        value={empTel}
                        onKeyDown={handleEnter}
                        type="number"
                        maxLength={10}
                        width="100%"
                      />
                    }
                  </td>
                </tr>
                <tr>
                  <td>
                    <label style={marginLeft}>สถานะการใช้งาน</label>
                    {
                      <FormGroup style={{ marginLeft: "10px" }}>
                        <FormControlLabel
                          control={
                            <Switch
                              checked={statusActive}
                              onChange={() => {
                                setStatusActive(!statusActive);
                              }}
                            />
                          }
                          label={
                            statusActive ? (
                              <label>เปิดการใช้งาน</label>
                            ) : (
                              <label>ปิดการใช้งาน</label>
                            )
                          }
                        />
                      </FormGroup>
                    }
                  </td>
                </tr>
              </table>
            </form>
          </DialogContent>
          <DialogActions>
            <ButtonSave type="submit" />
            <ButtonClose onClick={() => props.onCancel()} />
          </DialogActions>
          <Loading open={loading} />
        </Box>
      </Dialog>
    </>
  );
}

export default AddEmployee;
